import { ClientSettingsFilterResults } from "../model/reference/settingsTypes";
import { SimpleFilterResultsInfo } from "../components/SimpleFilterResultsInfo";
import { SeasonableInfo } from "../components/FilterResultHeader/FilterResultHeader";

export function resultsAreShown(
  filterResults: ClientSettingsFilterResults[],
  infos: SimpleFilterResultsInfo[] | null | undefined,
): boolean {
  const incoming = Array.isArray(infos) ? infos : [];

  const byName = new Map<string, SimpleFilterResultsInfo[]>();
  for (const i of incoming) {
    const arr = byName.get(i.name) ?? [];
    arr.push(i);
    byName.set(i.name, arr);
  }

  for (const r of filterResults) {
    for (const formInfo of r.info as SeasonableInfo[]) {
      const candidates = byName.get(formInfo.name) ?? [];
      const match = formInfo.options?.length
        ? candidates.find((i) => i.name === formInfo.name)
        : candidates.find((i) => i.name === formInfo.name && i.value === formInfo.value);

      const seasonsEqual = (match?.season ?? "") === (formInfo.season ?? "");

      if (formInfo.isSet) {
        if (
          !match?.isSet ||
          !seasonsEqual ||
          (formInfo.options?.length && match?.value !== formInfo.value)
        ) {
          return false;
        }
      } else if (match?.isSet) {
        return false;
      }
    }
  }
  return true;
}
